import { z } from 'zod';

export const updateUserProfileSchema = z.object({
  fullName: z.string().min(1).nullable().optional(),
  avatarUrl: z.string().url().nullable().optional(),
});

export type UpdateUserProfileInput = z.infer<typeof updateUserProfileSchema>;
